// Конфиги представления времени

export const CHART_DAY_TIMES = ['00:00:00', '04:00:00', '08:00:00', '12:00:00', '16:00:00', '20:00:00', '00:00:00'];
export const INIT_TIME = '00:00:00';
export const END_TIME = '23:59:59';
